import React, { useMemo } from 'react';

import { Column } from '@ant-design/plots';
import { Empty } from 'antd';

type Row = { role: string; count: number };

type Props = {
  rows: Row[];
};

export const RoleBarChart = ({ rows }: Props) => {
  const data = useMemo(
    () => rows.filter((r) => r.count > 0).sort((a, b) => b.count - a.count),
    [rows],
  );

  if (!data.length) {
    return <Empty description="No breakdown by role" />;
  }

  return (
    <Column
      data={data}
      xField="role"
      yField="count"
      autoFit
      height={300}
      style={{
        fill: '#722ed1',
        radiusTopLeft: 6,
        radiusTopRight: 6,
      }}
      axis={{
        x: { labelAutoRotate: data.length > 4 },
        y: { gridLineDash: [2, 2] },
      }}
      label={{
        text: 'count',
        position: 'top',
        style: { fill: '#434343', fontWeight: 600 },
      }}
      tooltip={{ title: 'role', items: [{ field: 'count' }] }}
    />
  );
};
